import { render, staticRenderFns } from "./example2.vue?vue&type=template&id=58b8c62c&lang=html&"
import script from "./example2.vue?vue&type=script&lang=js&"
export * from "./example2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "example2.vue"
export default component.exports